import gsap from 'gsap'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin)

export default class DrawLines {
	constructor() {
		this.containers = document.querySelectorAll('[data-drawlines]')
		this.timelines = []
		this.#init()
	}

	#init() {
		this.containers.forEach(container => this.#setupScrollTrigger(container))
	}

	#setupScrollTrigger(container) {
		const paths = container.querySelectorAll('[data-draw-path]')

		if (!paths.length) return

		const tl = gsap.timeline({ repeat: -1 })

		paths.forEach(path => {
			const reverse = path.hasAttribute('data-draw-reverse')
			const start = reverse ? '100% 100%' : '0 0'
			const middle = reverse ? '0 100%' : '0 100%'
			const end = reverse ? '0 0' : '100% 100%'

			tl.fromTo(path, { drawSVG: start }, { drawSVG: middle, duration: 5, ease: 'power1.inOut' }, 0)
			tl.to(path, { drawSVG: end, duration: 5, ease: 'power1.inOut' }, 4)
		})

		this.timelines.push(tl)
	}
}
